import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import Box from 'src/components/Box/Box'
import { SupportedBrands } from 'src/enums'
import {
  selectBrandName,
  selectIsExtendBrand,
} from 'src/redux/selectors/session.selectors'
import { css, CSSProp } from 'styled-components'

interface UnauthedBoxProps {
  className?: string
  topRightImage?: React.ReactElement
  bottomLeftImage?: React.ReactElement
  noInnerPadding?: boolean
  boxStyling?: CSSProp
}

const UnauthedBox: React.FC<React.PropsWithChildren<UnauthedBoxProps>> = (
  props,
) => {
  const isExtendBrand = useSelector(selectIsExtendBrand)
  const hideImages = useSelector(selectBrandName) === SupportedBrands.Jpm

  return (
    <Box
      className={props.className}
      css={css`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 600px;
        width: auto;
        padding: clamp(20px, 60px, 60px) clamp(20px, 100px, 100px);

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          width: 100%;
          padding: 60px 20px;
        `)}

        ${props.boxStyling}
      `}
      noPadding={props.noInnerPadding}
    >
      {isExtendBrand && (
        <>
          {props.topRightImage && !hideImages && (
            <div
              css={css`
                position: absolute;
                top: 0;
                right: 0;
                overflow: hidden;
                border-radius: 0px 10px 0px 0px;
              `}
            >
              {props.topRightImage}
            </div>
          )}
          {props.bottomLeftImage && !hideImages && (
            <div
              css={css`
                position: absolute;
                bottom: 0;
                left: 0;
                overflow: hidden;
                border-radius: 0px 10px 0px 0px;
              `}
            >
              {props.bottomLeftImage}
            </div>
          )}
        </>
      )}
      {props.children}
    </Box>
  )
}

export default UnauthedBox
